import { QUEUE_IDS } from 'customer-data-objects/task/TaskPropertyNames';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { DEFAULT_BULK_ACTIONS_EDIT_TASKS_MODAL_KEY } from '../../../constants/modalKeys';
import { useBulkActionsHasError } from '../../../hooks/useBulkActionsHasError';
import { useBulkActionsIsLoading } from '../../../hooks/useBulkActionsIsLoading';
import { useBulkActionsOpenModal } from '../../../hooks/useBulkActionsOpenModal';
import { useBulkActionsPermissionsForCurrentSelection } from '../../../hooks/useBulkActionsPermissionsForCurrentSelection';
import { BaseBulkActionButton } from '../BaseBulkActionButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const AddToQueue = ({
  modalProps
}) => {
  const openModal = useBulkActionsOpenModal();
  const isLoading = useBulkActionsIsLoading();
  const hasError = useBulkActionsHasError();
  const canBulkEditTasks = useBulkActionsPermissionsForCurrentSelection('canEdit');
  const disabled = isLoading || hasError || !canBulkEditTasks;
  const onClick = useCallback(() => {
    openModal({
      modalKey: DEFAULT_BULK_ACTIONS_EDIT_TASKS_MODAL_KEY,
      props: Object.assign({}, modalProps, {
        propertyName: QUEUE_IDS
      })
    });
  }, [modalProps, openModal]);
  return /*#__PURE__*/_jsx(BaseBulkActionButton, {
    "data-test-id": "bulk-actions-add-to-queue",
    disabled: disabled,
    disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "bulkActions.buttonDisabledTooltips.tasks.generic"
    }),
    icon: "add",
    isLoading: isLoading,
    onClick: onClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "bulkActions.buttonLabels.tasks.changeQueue"
    })
  });
};